import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import {
  HideIfTypingContainer,
  TypingContainer,
  WrapperDots,
  UserTypingWrapper,
} from 'components/page/Chat/Messenger/MessengerEditor/MessengerEditor.styled'
import { useHasUserRestrictions } from 'functions/hasUserRestrictions'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const TypingProcess: FC<{
  isTyping: boolean
}> = ({ isTyping }) => {
  return (
    <TypingContainer $isTyping={isTyping}>
      <FormattedMessage
        id="messenger.typing"
        defaultMessage="Пишет {dots}"
        values={{
          dots: (
            <WrapperDots>
              <span />
              <span />
              <span />
            </WrapperDots>
          ),
        }}
      />
    </TypingContainer>
  )
}

export const LocationAndStatusWriting: FC = () => {
  const { chatData, isTyping, isSupport } = useShallowEqualSelector(
    ({ chatMessengerReducer: { chatData, isTyping, isSupport } }) => ({
      chatData,
      isTyping,
      isSupport,
    })
  )

  const hasUserRestrictions = useHasUserRestrictions()

  if (isSupport && hasUserRestrictions) {
    return (
      <FormattedMessage
        id="support.contact"
        defaultMessage="Официальный контакт"
      />
    )
  }

  if (chatData && chatData.anketa) {
    if (chatData.anketa.isBot) {
      return (
        <FormattedMessage
          id="support.contact"
          defaultMessage="Официальный контакт"
        />
      )
    }

    if (chatData.anketa.lastVisit) {
      return (
        <UserTypingWrapper>
          <HideIfTypingContainer $isTyping={isTyping}>
            {chatData.anketa.lastVisit}
          </HideIfTypingContainer>
          <TypingProcess isTyping={isTyping} />
        </UserTypingWrapper>
      )
    }

    if (chatData.anketa.spaceTimeLocation) {
      return (
        <UserTypingWrapper>
          <HideIfTypingContainer $isTyping={isTyping}>
            {chatData.anketa.spaceTimeLocation.text}
          </HideIfTypingContainer>
          <TypingProcess isTyping={isTyping} />
        </UserTypingWrapper>
      )
    }

    return (
      <UserTypingWrapper>
        <TypingProcess isTyping={isTyping} />
      </UserTypingWrapper>
    )
  }

  return null
}
